import { useState, useCallback } from "react";

const useToggle = (initialState = false) => {
  const [on, _setOn] = useState(initialState);

  const [prevInitialState, setPrevInitialState] = useState(initialState);
  if (prevInitialState !== initialState) {
    setPrevInitialState(initialState);
    _setOn(initialState);
  }

  const reset = useCallback(() => {
    _setOn(initialState);
  }, [initialState]);

  const setOff = useCallback(() => {
    _setOn(false);
  }, []);

  const setOn = useCallback(() => {
    _setOn(true);
  }, []);

  const toggle = useCallback(() => {
    _setOn((cur) => !cur);
  }, []);

  return {
    on,
    reset,
    setOff,
    setOn,
    toggle,
  };
};

export { useToggle };
